var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePagePlayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#B4AB8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5804 14.6175L11.4861 9.66747C11.4179 9.62544 11.3398 9.60234 11.2598 9.60057C11.1797 9.5988 11.1006 9.61842 11.0307 9.6574C10.9608 9.69638 10.9025 9.7533 10.8619 9.82231C10.8213 9.89132 10.7999 9.96991 10.7998 10.05V19.95C10.7999 20.03 10.8213 20.1086 10.8619 20.1776C10.9025 20.2466 10.9608 20.3036 11.0307 20.3425C11.1006 20.3815 11.1797 20.4011 11.2598 20.3994C11.3398 20.3976 11.4179 20.3745 11.4861 20.3325L19.5804 15.3825C19.6469 15.3432 19.702 15.2872 19.7402 15.2201C19.7785 15.1531 19.7986 15.0772 19.7986 15C19.7986 14.9228 19.7785 14.8469 19.7402 14.7798C19.702 14.7127 19.6469 14.6568 19.5804 14.6175V14.6175Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePagePlayIcon);
export default __webpack_public_path__ + "static/media/home-page-play-icon.c732525c4f35e77604b16f8ea1eeb3db.svg";
export { ForwardRef as ReactComponent };